import "./PalletCheck.scss";

import config from "../../../config";

import React from "react";
import { inject, observer } from "mobx-react";
import { RouteNode } from "react-router5";

import Frame from "../Frame/Frame";
import PagerAmount from "../../Components/Pager/PagerAmount";
import Pager from "../../Components/Pager/Pager";
import Popup from "../../Components/Popup/Popup";
import RefreshButton from "../../Components/RefreshButton/RefreshButton";
import { STORE_CONFIG } from "../../Store/ConfigStore";
import { ROUTE_PALLET_CHECK, ROUTE_PALLET_CHECK_DETAILS } from "../../routes";
import {
  STORE_PALLET_CHECK,
  SORT_ASC,
  SORT_DESC,
} from "../../Store/PalletCheckStore";
import { STORE_AUTH } from "../../Store/AuthStore";
import axios from "axios";
import DatePicker, { registerLocale } from "react-datepicker";
import hu from "date-fns/locale/hu";
registerLocale("hu", hu);
import { formatDate, formatDateOnly } from "../../utility";
import { timeout } from "q";
import XLSX from "xlsx";

import Select from "react-select";
import { SelectStyle, DropdownIndicator } from "../App/select_style";
import Button from "../../Components/Button/Button";

const SORT_ID = "Id";
const SORT_MACHINE = "MachineText";
const SORT_CLEANINGRATE = "CleaningRateText";
const SORT_USER = "UserName";
const SORT_LOTNO = "LotNo";
const SORT_ITEM = "ItemName";
const SORT_BIN = "BinCode";
const SORT_AUTOBIN = "AutoBinCode";
const SORT_AMOUNT = "Quantity";
const SORT_CREATED = "Created";
const SORT_CHECKED = "CheckedName";
const SORT_TYPE = "TypeName";

// Bin codes may break after "/" (zero-width space), so long codes do not widen their column.
const breakableCode = (code) => (code ? code.replace(/\//g, "/​") : code);

function Sorter(props) {
  const asc = ["sorter__dir sorter__dir-asc"];
  const desc = ["sorter__dir sorter__dir-desc"];
  if (props.activeDirection === SORT_ASC) {
    asc.push("sorter__dir--active");
  } else if (props.activeDirection === SORT_DESC) {
    desc.push("sorter__dir--active");
  }
  return (
    <div
      className={"sorter" + (props.activeDirection ? " sorter--active" : "")}
    >
      <div className={asc.join(" ")} title="rendezés növekvő sorrendbe" />
      <div className={desc.join(" ")} title="rendezés csökkenő sorrendbe" />
    </div>
  );
}

const TableSearch = inject((stores) => ({
  store: stores.store.get(STORE_PALLET_CHECK),
}))(
  observer((props) => {
    const { store } = props;
    const cancelClassname =
      "search-cancel-button" + (store.searchtext.length > 0 ? "" : " hidden");
    return (
      <div className="table-search">
        <div className="table-search__label">Keresés</div>
        {/*<div className="table-search__input-container">      
        <input className="form-input form-input--inline" type="text" name="focus" value={store.search} onChange={e => store.setSearch(e.target.value)} />       
    </div>*/}
        <div className="search-wrapper">
          <input
            className="search-input"
            value={store.searchtext}
            onChange={(e) => store.setSearchText(e.target.value)}
          />
          <div
            className={cancelClassname}
            onClick={(e) => {
              store.setSearchText("");
              store.setSearch();
            }}
          >
            <i className="fas fa-times"></i>
          </div>
        </div>
        <div
          className="btn searchbutton"
          onClick={(e) => {
            store.setSearch(store.searchtext);
          }}
        >
          Keres
        </div>
      </div>
    );
  })
);

@inject((stores) => ({
  store: stores.store.get(STORE_PALLET_CHECK),
  configStore: stores.store.get(STORE_CONFIG),
  authStore: stores.store.get(STORE_AUTH),
  socket: stores.socket,
  router: stores.router,
}))
@observer
class PalletCheck extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      popup: "none",
      popupText: "",
      from: null,
      to: null,
      subtable: null,
    };

    this.refresh();
  }
  onClickSort = (field) => () => {
    const { store } = this.props;
    if (store.sortField === field) {
      store.flipSortDirection();
    } else {
      store.setSortField(field);
      store.setSortDirection(SORT_ASC);
    }
  };
  typedValue = (value) => {
    return {
      t: isNaN(value) ? "s" : "n",
      v: value,
    };
  };

  refresh() {
    const { store, socket } = this.props;

    const _this = this;
    socket.emitWithToken("GetPalletsCheck", {}, function (err, data) {
      if (err) {
        console.error(err);
        return;
      }
      store.setItems(data);
      _this.setState({ newContentAvailable: false });
    });
  }

  showPopup = (text) => {
    this.setState({ popup: "show", popupText: text });
  };

  handleDownload() {
    const { store, configStore } = this.props;
    const { sortedItems } = store;

    const header = [
      "Azonosító",
      "Gép",
      "Fok",
      "Felhasználó",
      "Cikk",
      "Könyvelt hely",
      "Mért hely",
      "Mért hely 2",
      "Mennyiség",
      "Létrehozva",
      "Incidens típusa",
      "Állapot",
    ];

    const merges = [];
    let data = [header];

    sortedItems.forEach((pallet) => {
      let row = [
        pallet.LotNo + (pallet.SealNum ? " (" + pallet.SealNum + ")" : ""),
        pallet.MachineText +
          (pallet.Dressing ? "(" + pallet.Dressing + ")" : ""),
        pallet.CleaningRateText +
          (pallet.CustomCleaningRate
            ? " (" + pallet.CustomCleaningRate + ")"
            : ""),
        pallet.UserName,
        pallet.ItemName +
          (pallet.CustomItem ? " (" + pallet.CustomItem + ")" : ""),
        pallet.BinCode,
        (pallet.AutoBin && pallet.AutoBin.Code) || "",
        (pallet.AutoBin2 && pallet.AutoBin2.Code) || "",
        (pallet.BagType === 2
          ? pallet.BagCount + " x " + pallet.Quantity
          : pallet.Quantity) + " kg",
        pallet.Created,
        pallet.TypeName,
        pallet.CheckedName,
      ];

      data.push(row);
    });
    //console.log(data, merges)

    var wb = XLSX.utils.book_new();
    var ws = XLSX.utils.aoa_to_sheet(data);
    ws["!merges"] = merges;
    XLSX.utils.book_append_sheet(wb, ws, "Raklap ellenőrzés");

    XLSX.writeFile(
      wb,
      "Raklap ellenőrzés_" + formatDateOnly(new Date()) + ".xlsx",
      {
        bookSST: true,
        compression: true,
      }
    );
  }

  render() {
    const { store, configStore, authStore, route, router, socket } = this.props;
    const {
      shownItems,
      sortDirection,
      sortField,
      pager,
      uploading,
      hideChecked,
    } = store;
    const { itemCount, lastShownItem, firstShownItem } = pager;
    let { name: routeName, params: routeParams } = route;

    let rows = [];
    shownItems.forEach((pallet) => {
      store.palletHistory &&
        store.palletHistory.PalletId === pallet.Id &&
        console.log(configStore.machines);

      rows.push(
        <tr key={pallet.Id}>
          <td className="table-cell-active">
            <span
              className={
                (pallet.CleaningCount > 1 ? "bold" : "normal") +
                (!pallet.ThisSeason ? " offseasonpallet" : "")
              }
            >
              {pallet.LotNo}
            </span>
            {pallet.SealNum ? <br /> : null}{" "}
            {pallet.SealNum ? "(" + pallet.SealNum + ")" : ""}
          </td>
          <td>
            <span>
              {pallet.MachineText} {pallet.Dressing ? <br /> : null}{" "}
              {pallet.Dressing ? "(" + pallet.Dressing + ")" : null}
            </span>
          </td>
          <td>
            {pallet.CleaningRateText +
              (pallet.CustomCleaningRate
                ? " (" + pallet.CustomCleaningRate + ")"
                : "")}
          </td>
          <td>{pallet.UserName}</td>
          <td className={pallet.HasMixedItems ? " blue-text" : ""}>
            {pallet.ItemName} {pallet.CustomItem ? <br /> : null}{" "}
            {pallet.CustomItem ? "(" + pallet.CustomItem + ")" : ""}
          </td>
          <td>{breakableCode(pallet.BinCode)}</td>
          <td>
            {[pallet.AutoBin, pallet.AutoBin2]
              .filter((bin) => bin && bin.Code)
              .map((bin) => (
                <div key={bin.Id}>{breakableCode(bin.Code)}</div>
              ))}
          </td>
          <td>
            {(pallet.BagType === 2
              ? pallet.BagCount + " x " + pallet.Quantity
              : pallet.Quantity) + " kg"}
          </td>
          <td>{pallet.Created}</td>
          <td>{pallet.TypeName}</td>
          <td>{pallet.CheckedName}</td>
          <td>
            <div
              className="table_inrow_button"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                store.setSelectedPalletId([pallet.Id]);
                router.navigate(ROUTE_PALLET_CHECK_DETAILS);
              }}
            >
              Ellenőrzés
            </div>
          </td>
        </tr>
      );
    });

    return (
      <Frame>
        <div className="table basic-content">
          <div className="table__top">
            <div className="table-pager-amount">
              <PagerAmount
                perPage={pager.perPage}
                onChange={(e) => pager.setPerPage(e.value)}
              />
            </div>
            <Select
              className="react-select checkdetails-select-levels"
              options={store.typeOptions}
              onChange={(e) => store.setTypeOption(e)}
              value={store.typeOption}
              isSearchable={false}
              styles={SelectStyle}
              components={{ DropdownIndicator }}
            />
            <div className="table-checkbox-block">
              <input
                id="showTerminatedCheckbox"
                type="checkbox"
                name="showTerminated"
                value="showTerminated"
                checked={!hideChecked}
                onClick={() => {
                  store.changeHideChecked();
                }}
              />
              <label
                className="table-checkbox-label"
                htmlFor="showTerminatedCheckbox"
              >
                <span></span>
                <div className="table-checkbox-title">
                  Ellenőrzöttek mutatása
                </div>
              </label>
            </div>
            <TableSearch />

            <Button
              className="mixedPallet__editbutton"
              onClick={() => this.handleDownload()}
            >
              Excel letöltés
            </Button>

            <RefreshButton
              onClick={() => {
                this.refresh();
              }}
              newContentAvailable={this.state.newContentAvailable}
            />
          </div>
          <div className="table__content">
            <table className="palletcheck-table">
              <thead>
                <tr>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_LOTNO)}
                    >
                      Azonosító
                      <Sorter
                        activeDirection={
                          sortField === SORT_LOTNO ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_MACHINE)}
                    >
                      Gép
                      <Sorter
                        activeDirection={
                          sortField === SORT_MACHINE ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_CLEANINGRATE)}
                    >
                      Fok
                      <Sorter
                        activeDirection={
                          sortField === SORT_CLEANINGRATE ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_USER)}
                    >
                      Felhasználó
                      <Sorter
                        activeDirection={
                          sortField === SORT_USER ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_ITEM)}
                    >
                      Cikk
                      <Sorter
                        activeDirection={
                          sortField === SORT_ITEM ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_BIN)}
                    >
                      Könyvelt hely
                      <Sorter
                        activeDirection={
                          sortField === SORT_BIN ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_AUTOBIN)}
                    >
                      Mért hely(ek)
                      <Sorter
                        activeDirection={
                          sortField === SORT_AUTOBIN ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_AMOUNT)}
                    >
                      Mennyiség
                      <Sorter
                        activeDirection={
                          sortField === SORT_AMOUNT ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_CREATED)}
                    >
                      Létrehozva
                      <Sorter
                        activeDirection={
                          sortField === SORT_CREATED ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_TYPE)}
                    >
                      Incidens típusa
                      <Sorter
                        activeDirection={
                          sortField === SORT_TYPE ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_CHECKED)}
                    >
                      Állapot
                      <Sorter
                        activeDirection={
                          sortField === SORT_CHECKED ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div className="table__header-cell" />
                  </th>
                </tr>
              </thead>
              <tbody className="table_body">{rows}</tbody>
            </table>
          </div>
          <div className="table__bottom">
            <div>
              {firstShownItem} - {lastShownItem} találat mutatása {itemCount}{" "}
              közül
            </div>
            <Pager
              routeName={routeName}
              routeParams={routeParams}
              pager={pager}
              onClickPage={(page) => pager.setCurrentPage(page)}
            />
          </div>
        </div>
        {this.state.popup === "none" ? null : (
          <Popup
            key="popup"
            text={this.state.popupText}
            onClickClose={() => this.setState({ popup: "none" })}
          />
        )}
      </Frame>
    );
  }
}

export {
  SORT_ASC,
  SORT_DESC,
  SORT_ID,
  SORT_MACHINE,
  SORT_CLEANINGRATE,
  SORT_LOTNO,
  SORT_AMOUNT,
  SORT_CREATED,
  SORT_BIN,
  SORT_AUTOBIN,
  SORT_ITEM,
  SORT_CHECKED,
  SORT_USER,
  SORT_TYPE,
};

export default (props) => (
  <RouteNode nodeName={ROUTE_PALLET_CHECK}>
    {(routeProps) => <PalletCheck {...routeProps} {...props} />}
  </RouteNode>
);
